import StoreModuleService from '../StoreModuleService';
import { MODULE_NAME } from './const';
import state from './state';
import { SET_WIDGET_DATA, PARTIAL_UPDATE_WIDGET_DATA, BULK_SET_WIDGETS_DATA } from './mutations';
import api from '@/api';
import { arrayToObject, isNullOrUndefined } from '@/utils/helpers';
import { getActionsOfApp } from '../apps/actions';

import { getConfiguration } from '../workflowConfigurations/actions';

const buildWidgetActionObject = (action) => StoreModuleService.buildActionObject(MODULE_NAME, action);

// actions declarations
export const setWidgetData = buildWidgetActionObject('setWidgetData');
export const getWidgetData = buildWidgetActionObject('getWidgetData');
export const getWidgetFieldsServiceActions = buildWidgetActionObject('getWidgetFieldsServiceActions');
export const fetchWidgetData = buildWidgetActionObject('fetchWidgetData');
export const bulkFetchWidgetsData = buildWidgetActionObject('bulkFetchWidgetsData');
export const updateWidgetData = buildWidgetActionObject('updateWidgetData');
export const addFieldToWidget = buildWidgetActionObject('addFieldToWidget');
export const saveWidget = buildWidgetActionObject('saveWidget');

export const assignWidgetFieldCredentialsSourceField = buildWidgetActionObject('assignWidgetFieldCredentialsSourceField');

const actions = {
	...StoreModuleService.createDefaultActions(),
	async [getWidgetData.action]({ dispatch }, payload) {
		const { id, workflowId, workflowVersionId, published, forceGet } = payload;
		const dataIsMissing = isNullOrUndefined(state.data[id]); // TODO, should we save the widget in state by its id, or by its id + workflowId?
		const needToGet = dataIsMissing || forceGet;
		if (needToGet) {
			await dispatch(fetchWidgetData.action, { id, workflowId, workflowVersionId, published });
		}
	},
	[setWidgetData.action]({ commit }, payload) {
		const { data: widgetData, partial } = payload;
		if (partial) {
			commit(PARTIAL_UPDATE_WIDGET_DATA, { key: widgetData.id, value: widgetData });
		} else {
			commit(SET_WIDGET_DATA, { key: widgetData.id, value: widgetData });
		}
	},
	async [fetchWidgetData.action]({ dispatch }, payload) {
		const { id, workflowId, workflowVersionId, published } = payload;
		const ret = await api.getWidget(id, workflowId, workflowVersionId, published);
		await dispatch(updateWidgetData.action, { data: ret });
	},
	async [bulkFetchWidgetsData.action]({ commit, dispatch }, payload) {
		const { widgetIds, workflowVersionId } = payload;
		const ret = await api.getWidgets(widgetIds, workflowVersionId);
		commit(BULK_SET_WIDGETS_DATA, { data: arrayToObject(ret) });
		await Promise.all(
			ret.map((widget) => {
				dispatch(getWidgetFieldsServiceActions.action, { data: widget });
			})
		);
	},
	async [getWidgetFieldsServiceActions.action]({ dispatch }, { data: widget }) {
		const { fields } = widget;
		// get all related data to the widget fields
		await Promise.all(
			fields
				.filter((field) => !!field.metadata.source?.service)
				.map((field) =>
					dispatch(
						getActionsOfApp.fullPath,
						{ id: field.metadata.source.service, version: field.metadata.source.service_version },
						{ root: true }
					)
				)
		);
	},
	async [updateWidgetData.action]({ dispatch }, payload) {
		const { data: widget } = payload;
		await dispatch(getWidgetFieldsServiceActions.action, { data: widget });
		await dispatch(setWidgetData.action, { data: widget });
	},
	async [addFieldToWidget.action]({ dispatch }, payload) {
		const { id, workflowId, workflowVersionId, interfaceFieldPayload, configurationId } = payload;
		const res = await api.addFieldToWidgetAPI(workflowId, interfaceFieldPayload);
		await dispatch(getWidgetData.action, { id, workflowId, workflowVersionId, forceGet: true });
		await dispatch(getConfiguration.fullPath, { id: configurationId, forceGet: true }, { root: true });
		return res;
	},
	async [saveWidget.action]({ dispatch }, payload) {
		const { data } = payload;
		const { id: widgetID, fields, title: widgetTitle, metadata: widgetMetadata, workflowVersionId } = data;
		for (let index = 0; index < fields.length; index++) {
			const element = fields[index];
			if (element) {
				element.order = index;
			}
		}

		const ret = await api.saveWidget(widgetID, fields, widgetTitle, widgetMetadata, workflowVersionId);

		dispatch(setWidgetData.action, { data: { id: widgetID, fields: ret.fields, metadata: ret.metadata }, partial: true });

		return ret;
	},
	async [assignWidgetFieldCredentialsSourceField.action](ctx, payload) {
		const { widgetFieldId, workflowVersionId } = payload;
		const ret = await api.assignWidgetFieldCredentialsSourceField(widgetFieldId, workflowVersionId);
		return ret;
	},
};

export default actions;
